import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/components/Layout/PCLayout'
import ReaderLayout from '@/components/Layout/ReaderLayout'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    { path: '*', redirect: '/' },
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          name: 'Index',
          meta: { title: '首页' },
          component: () => import('@/pages/Index/Index')
        }
      ]
    },
    {
      path: '/bookshelf',
      component: Layout,
      children: [
        {
          path: '',
          name: 'BookShelf',
          meta: { title: '书架' },
          component: () => import('@/pages/BookShelf/BookShelf')
        }
      ]
    },
    {
      path: '/hasread',
      component: Layout,
      children: [
        {
          path: '',
          name: 'HasRead',
          meta: { title: '最近阅读' },
          component: () => import('@/pages/HasRead/HasRead')
        }
      ]
    },
    {
      path: '/hasbuy',
      component: Layout,
      children: [
        {
          path: '',
          name: 'hasbuy',
          meta: { title: '书架' },
          component: () => import('@/pages/HasBuy/HasBuy')
        }
      ]
    },
    {
      path: '/buy',
      component: Layout,
      children: [
        {
          path: '',
          name: 'Buy',
          meta: { title: '购买' },
          component: () => import('@/pages/Buy/Buy')
        }
      ]
    },
    {
      path: '/reader',
      component: ReaderLayout,
      children: [
        {
          path: '',
          name: 'Reader',
          meta: { title: '阅读' },
          component: () => import('@/pages/Reader/Reader')
        }
      ]
    },
    {
      path: '/install360',
      component: ReaderLayout,
      children: [
        {
          path: '',
          name: 'Install360',
          meta: { title: '网上新标准360浏览器使用教程' },
          component: () => import('@/pages/Install360/Install360')
        }
      ]
    },
    {
      path: '/installExeInstructions',
      component: ReaderLayout,
      children: [
        {
          path: '',
          name: 'InstallExeInstructions',
          meta: { title: '网上新标准安装升级说明' },
          component: () => import('@/pages/InstallExeInstructions/InstallExeInstructions')
        }
      ]
    },
    {
      path: '/poster',
      name: 'Poster',
      meta: {
        title: '创建海报',
        noLogin: true
      },
      component: () => import('@/pages/Poster/Poster')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/modules/pc/router/index.js